import { RootState } from 'reducers';

export const loginWith2FARecomendationSelector = (state: RootState) =>
  state.components.loginWith2FARecomendation.visible;
